<template>
  <div class="h-full d-flex flex-column autoscroll-y mt-4 overflow-hidden">
    <UploadChange @reset="$emit('reset')" />
    <mcs-sheet
      outlined
      no-padding
      class="d-flex h-full flex-column autoscroll-y mt-4"
    >
      <div class="d-flex h-full flex-column autoscroll-y">
        <UploadAddressesOverview
          v-if="tab == 0"
          @change="tab = 1"
        />
        <UploadAddressesList
          v-else-if="tab == 1"
          @change="tab = 0"
        />
      </div>
      <v-divider />
      <mcs-btn
        large
        color="black"
        text
        @click="tab = tab == 0 ? 1 : 0"
      >
        {{ tab == 0 ? 'View Full List >' : '&lt; View Overview' }}
      </mcs-btn>
    </mcs-sheet>
  </div>
</template>

<script>
import UploadAddressesList from '@/components/print/checkout/snailblast/upload/addresses/List';
import UploadAddressesOverview from '@/components/print/checkout/snailblast/upload/addresses/Overview';
import UploadChange from '@/components/print/checkout/snailblast/upload/Change';
import { ANALYTICS_EVENTS, APP_EVENTS } from '@/utils/constants';
import { mapGetters } from 'vuex';
import snailblast from '@/utils/mixins/snailblast';
export default {
  name: 'SnailblastUploadAddresses',
  components: {
    UploadAddressesOverview,
    UploadAddressesList,
    UploadChange
  },
  mixins: [snailblast],
  data: () => ({
    loading: false,
    tab: 0
  }),
  computed: {
    campaign: {
      get() {
        return this.$store.getters['snailblast/campaign/edit_campaign'];
      },
      set(val) {
        this.$store.dispatch('snailblast/campaign/setEditCampaign', val);
      }
    },
    saving: {
      get() {
        return this.$store.getters['snailblast/campaign/saving'];
      },
      set(val) {
        this.$store.dispatch('snailblast/campaign/setSaving', val);
      }
    },
    ...mapGetters({
      addresses: 'snailblast/campaign/addresses',
      price: 'printcart/price',
      address_count: 'snailblast/campaign/address_count',
      analytics_data: 'snailblast/campaign/analytics_data'
    })
  },
  watch: {
    tab(val, oldVal) {
      if (val !== oldVal) {
        const screen =
          val === 0
            ? ANALYTICS_EVENTS.MAILING_SERVICE.SCREENS.UPLOAD_OVERVIEW
            : ANALYTICS_EVENTS.MAILING_SERVICE.SCREENS.UPLOAD_VIEW_LIST;
        this.$mixpanel.trackEvent(
          ANALYTICS_EVENTS.MAILING_SERVICE.NAME,
          null,
          Object.assign(this.analytics_data, { screen })
        );
      }
    }
  },
  mounted() {
    this.$mixpanel.trackEvent(
      ANALYTICS_EVENTS.MAILING_SERVICE.NAME,
      null,
      Object.assign(this.analytics_data, {
        screen: ANALYTICS_EVENTS.MAILING_SERVICE.SCREENS.UPLOAD_OVERVIEW
      })
    );
    this.updatePrice();
  },
  methods: {
    updatePrice() {
      this.$eventBus.$emit(APP_EVENTS.GET_EDIT_ITEM_PRICE, { source: 'upload' });
    },
    save() {
      this.saving = true;
      this.$store
        .dispatch('snailblast/campaign/refresh', this.campaign.id)
        .then(() => {
          this.afterSave({
            mailing_service: 'upload',
            audience_size: this.address_count,
            price: this.price
          });
        })
        .catch((error) => {
          this.logError(error, 'Error refreshing campaign');
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>
